import * as i0 from '@angular/core';
import { Injectable, Component, Input, ViewChild, NgModule } from '@angular/core';
import { map, takeUntil } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { Subject } from 'rxjs';
import * as i2 from 'ngx-toastr';
import * as i3 from '@ngrx/store';
import * as i4 from '@angular/forms';
import * as i5 from 'primeng/inputtext';
import * as i6 from '@angular/common';
import * as i7 from 'primeng/divider';
import * as i8 from 'primeng/tooltip';
import * as i9 from 'primeng/button';
import { PrimengLibraryModule } from 'primeng-library';

class InCareOfNameService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getInCareOfName(caseId, isGcCase = false) {
        const apiFlag = isGcCase ? `gcCase` : `petition`;
        return this.httpClient.get(`/${apiFlag}/${caseId}/careofname`).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    saveInCareOfName(payload = {}) {
        const apiFlag = (payload === null || payload === void 0 ? void 0 : payload.gcI140CaseId) ? `gcCase` : `petition`;
        return this.httpClient.post(`/${apiFlag}/save/careofname`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    getReviewersUser(companyId, permissionName) {
        return this.httpClient.get(`/company/${companyId}/employee?permissionName=${permissionName}`).pipe(map((response) => response.data));
    }
    getTask(taskId) {
        return this.httpClient.get(`/task/${taskId}`).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
        }));
    }
}
InCareOfNameService.ɵfac = function InCareOfNameService_Factory(t) { return new (t || InCareOfNameService)(i0.ɵɵinject(i1.HttpClient)); };
InCareOfNameService.ɵprov = i0.ɵɵdefineInjectable({ token: InCareOfNameService, factory: InCareOfNameService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InCareOfNameService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

const _c0 = ["inCareOfNameField"];
function InCareOfNameComponent_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function InCareOfNameComponent_button_7_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); ctx_r3.isDefaultInCareOfName = true; return ctx_r3.onChangeCareNameCheckbox($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r1.disabledControls);
} }
function InCareOfNameComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelementStart(1, "button", 10);
    i0.ɵɵlistener("click", function InCareOfNameComponent_div_8_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.saveInCareName(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "button", 11);
    i0.ɵɵlistener("click", function InCareOfNameComponent_div_8_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r6); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.closeInCareName(); });
    i0.ɵɵelement(3, "span", 12);
    i0.ɵɵelementStart(4, "span", 13);
    i0.ɵɵtext(5, "\u00A0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r2.inCareOfName == "" || ctx_r2.disabledControls);
} }
class InCareOfNameComponent {
    constructor(apiService, toastr, store) {
        this.apiService = apiService;
        this.toastr = toastr;
        this.store = store;
        this.disabledControls = false;
        this.isDefaultInCareOfName = false;
        this.inCareOfName = '';
        this.defaultValue = '';
        this.observableSubscription$ = new Subject();
    }
    ngOnInit() {
        var _a;
        this.apiService.getInCareOfName(this.petitionId, (((_a = this.inputData) === null || _a === void 0 ? void 0 : _a.caseType) === 'I140')).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            var _a, _b;
            if (response.data) {
                if (!response.data.inCareOfName || null == response.data.inCareOfName) {
                    this.getAndSaveSignatory();
                }
                else {
                    this.defaultValue = (_a = response.data) === null || _a === void 0 ? void 0 : _a.inCareOfName;
                    this.inCareOfName = (_b = response.data) === null || _b === void 0 ? void 0 : _b.inCareOfName;
                }
            }
        });
    }
    getAndSaveSignatory() {
        this.apiService.getTask(this.inputData['subTaskId'])
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((data) => {
            if (data['signatoryDetails']) {
                const authorizedSignatoryName = `${data['signatoryDetails'].firstName} ${data['signatoryDetails'].lastName}`;
                this.defaultValue = authorizedSignatoryName;
                this.inCareOfName = authorizedSignatoryName;
                this.saveInCareName(false);
            }
        });
    }
    onChangeCareNameCheckbox(event) {
        if (this.isDefaultInCareOfName) {
            setTimeout(() => {
                this.inCareOfNameField.nativeElement.focus();
            });
        }
        else {
            //set inout feild initial value if not saved
            this.inCareOfName = this.defaultValue;
        }
    }
    closeInCareName() {
        this.isDefaultInCareOfName = false;
        //set inout feild initial value
        this.inCareOfName = this.defaultValue;
    }
    saveInCareName(showMessage = true) {
        var _a, _b;
        //Save API call
        let payload = {
            "inCareOfName": this.inCareOfName
        };
        if (((_a = this.inputData) === null || _a === void 0 ? void 0 : _a.caseType) === 'I140') {
            payload = Object.assign({ gcI140CaseId: (_b = this.inputData) === null || _b === void 0 ? void 0 : _b.caseId }, payload);
        }
        else {
            payload = Object.assign({ petitionId: this.petitionId }, payload);
        }
        this.apiService.saveInCareOfName(payload).subscribe((response) => {
            if (response && response.status === 200) {
                if (showMessage) {
                    this.toastr.success(response.message, 'Success');
                }
                this.isDefaultInCareOfName = false;
                this.defaultValue = this.inCareOfName;
            }
        });
    }
}
InCareOfNameComponent.ɵfac = function InCareOfNameComponent_Factory(t) { return new (t || InCareOfNameComponent)(i0.ɵɵdirectiveInject(InCareOfNameService), i0.ɵɵdirectiveInject(i2.ToastrService), i0.ɵɵdirectiveInject(i3.Store)); };
InCareOfNameComponent.ɵcmp = i0.ɵɵdefineComponent({ type: InCareOfNameComponent, selectors: [["lib-in-care-of-name"]], viewQuery: function InCareOfNameComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 1);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inCareOfNameField = _t.first);
    } }, inputs: { petitionId: "petitionId", disabledControls: "disabledControls", inputData: "inputData" }, decls: 10, vars: 4, consts: [[1, "row", "col-md-12", "pt-2", "pb-2"], [1, "sub-title"], [1, "row", "pb-2", "incareofname-block"], [1, "col-md-6", "d-flex"], ["type", "text", "pInputText", "", "placeholder", "Enter In Care of Name", "name", "inCareOfName", "id", "inCareName-input", "required", "", 3, "disabled", "ngModel", "ngModelChange"], ["inCareOfNameField", ""], ["type", "button", "pTooltip", "Click on pencil if you want to change the in care of name", "pButton", "", "icon", "pi pi-pencil", "class", "p-button-text p-button-rounded ml-3", 3, "disabled", "click", 4, "ngIf"], ["class", "pl-2 d-flex", 4, "ngIf"], ["type", "button", "pTooltip", "Click on pencil if you want to change the in care of name", "pButton", "", "icon", "pi pi-pencil", 1, "p-button-text", "p-button-rounded", "ml-3", 3, "disabled", "click"], [1, "pl-2", "d-flex"], ["type", "button", "pButton", "", "pRipple", "", "styleClass", "p-button-success", "label", "Save", 3, "disabled", "click"], ["type", "button", 1, "ml-2", "p-button", "p-component", "p-button-icon-only", "cancel-btn", 3, "click"], [1, "p-button-icon", "pi", "pi-times"], [1, "p-button-label"]], template: function InCareOfNameComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "h5", 1);
        i0.ɵɵtext(2, "In Care of Name Details");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵelementStart(5, "input", 4, 5);
        i0.ɵɵlistener("ngModelChange", function InCareOfNameComponent_Template_input_ngModelChange_5_listener($event) { return ctx.inCareOfName = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, InCareOfNameComponent_button_7_Template, 1, 1, "button", 6);
        i0.ɵɵtemplate(8, InCareOfNameComponent_div_8_Template, 6, 1, "div", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(9, "p-divider");
    } if (rf & 2) {
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("disabled", !ctx.isDefaultInCareOfName || ctx.disabledControls)("ngModel", ctx.inCareOfName);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.isDefaultInCareOfName);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isDefaultInCareOfName);
    } }, directives: [i4.DefaultValueAccessor, i5.InputText, i4.RequiredValidator, i4.NgControlStatus, i4.NgModel, i6.NgIf, i7.Divider, i8.Tooltip, i9.ButtonDirective], styles: ["h5.sub-title[_ngcontent-%COMP%]{color:#3d3d63;font-size:18px;font-weight:600;margin-bottom:0;font-family:Source Sans Pro,Semibold}.incareofname-block[_ngcontent-%COMP%]   .p-inputtext[_ngcontent-%COMP%]{width:70%}.incareofname-block[_ngcontent-%COMP%]   .p-inputtext.ng-invalid[_ngcontent-%COMP%]{border-color:#f44336!important}.incareofname-block[_ngcontent-%COMP%]   .cancel-btn[_ngcontent-%COMP%]{border:none!important}.incareofname-block[_ngcontent-%COMP%]   .cancel-btn[_ngcontent-%COMP%], .incareofname-block[_ngcontent-%COMP%]   .cancel-btn[_ngcontent-%COMP%]   [_ngcontent-%COMP%]:hover{background:transparent!important;color:#2196f3!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InCareOfNameComponent, [{
        type: Component,
        args: [{
                selector: 'lib-in-care-of-name',
                templateUrl: 'in-care-of-name.component.html',
                styleUrls: ['in-care-of-name.component.scss']
            }]
    }], function () { return [{ type: InCareOfNameService }, { type: i2.ToastrService }, { type: i3.Store }]; }, { petitionId: [{
            type: Input
        }], disabledControls: [{
            type: Input
        }], inputData: [{
            type: Input
        }], inCareOfNameField: [{
            type: ViewChild,
            args: ['inCareOfNameField']
        }] }); })();

class InCareOfNameModule {
}
InCareOfNameModule.ɵfac = function InCareOfNameModule_Factory(t) { return new (t || InCareOfNameModule)(); };
InCareOfNameModule.ɵmod = i0.ɵɵdefineNgModule({ type: InCareOfNameModule });
InCareOfNameModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(InCareOfNameModule, { declarations: [InCareOfNameComponent], imports: [PrimengLibraryModule], exports: [InCareOfNameComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InCareOfNameModule, [{
        type: NgModule,
        args: [{
                declarations: [InCareOfNameComponent],
                imports: [
                    PrimengLibraryModule
                ],
                exports: [InCareOfNameComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of in-care-of-name
 */

/**
 * Generated bundle index. Do not edit.
 */

export { InCareOfNameComponent, InCareOfNameModule, InCareOfNameService };
//# sourceMappingURL=in-care-of-name.js.map
